import React, { useState } from "react";

const JoinExplorer = ({
  joinedTables,
  joinsByTable,
  alreadyJoined,
  onJoinTable,
}) => {
  const [joinTypes, setJoinTypes] = useState({});

  if (!joinedTables || joinedTables.length === 0) return null;

  const handleJoinTypeChange = (joinTo, type) => {
    setJoinTypes((prev) => ({ ...prev, [joinTo]: type }));
  };

  return (
    <div className="mb-4">
      <label className="form-label fw-bold">
        Step 3: Add Joins (from any selected table)
      </label>

      {joinedTables.map((sourceTable) => {
        const joins = joinsByTable[sourceTable] || [];

        // Filter out already joined tables
        const validJoins = joins.filter(
          (join) => !alreadyJoined.includes(join.joinTo)
        );

        if (validJoins.length === 0) return null;

        return (
          <div key={sourceTable} className="mb-3">
            <h6 className="text-primary">Join from: {sourceTable}</h6>
            <ul className="list-group">
              {validJoins.map((join, idx) => {
                const joinTo = join.joinTo;
                const joinType = joinTypes[joinTo] || "left"; // default LEFT JOIN

                return (
                  <li
                    key={idx}
                    className="list-group-item d-flex flex-column gap-2"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        ➝ <strong>{joinTo}</strong> ({join.fromColumn} ={" "}
                        {join.toColumn})
                      </span>

                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() =>
                          onJoinTable(
                            joinTo,
                            sourceTable,
                            join.fromColumn,
                            join.toColumn,
                            joinType // include type
                          )
                        }
                      >
                        Join
                      </button>
                    </div>

                    <div className="d-flex align-items-center">
                      <label className="form-label me-2 mb-0">Join type:</label>
                      <select
                        className="form-select form-select-sm w-auto"
                        value={joinType}
                        onChange={(e) =>
                          handleJoinTypeChange(joinTo, e.target.value)
                        }
                      >
                        <option value="left">Optional (LEFT JOIN)</option>
                        <option value="inner">Required (INNER JOIN)</option>
                      </select>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default JoinExplorer;
